import data from "../../../../../src/Dialog2/Dialog.docs.json";
import State from "../../../../components/State";
import * as React from 'react';
export default {
  data,
  State,
  React
};